import { ButtonHTMLAttributes } from 'react';
import styled from '../../lib/theme';

export const CSATSurveyContainer = styled('div')`
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  gap: 24px;
  left: 50%;
  padding: 18px;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: calc(95% - 36px);

  > div:first-of-type {
    margin-bottom: 4px;
  }

  > div:last-of-type {
    margin-top: 4px;
  }
`;

interface IButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  filled?: boolean;
}

export const Button = styled('button')<IButtonProps>`
  align-items: center;
  background-color: ${(props) => (props.filled ? props.theme.primaryAccentColor : props.theme.primaryAccentTextColor)};
  border-radius: 50%;
  border: 0.1rem solid ${(props) => props.theme.primaryAccentColor};
  color: ${(props) => (props.filled ? props.theme.primaryAccentTextColor : props.theme.primaryAccentColor)};
  cursor: pointer;
  display: flex;
  font-family: inherit;
  font-size: 100%;
  height: 3.2rem;
  justify-content: center;
  opacity: ${(props) => (props.disabled ? 0.3 : 1)};
  padding: 1rem;
  width: 3.2rem;
`;

interface IFlexContainerProps {
  center?: boolean;
  spaceBetween?: boolean;
  padding?: boolean;
  flexEnd?: boolean;
  flexCol?: boolean;
  gap?: number;
}

export const FlexContainer = styled('div')<IFlexContainerProps>`
  display: flex;
  ${(props) => (props.center ? 'justify-content: center;' : '')}
  ${(props) => (props.spaceBetween ? 'justify-content: space-between;' : '')}
  ${(props) => (props.padding ? 'padding: 0 1rem;' : '')}
  ${(props) => (props.flexEnd ? 'justify-content: flex-end;' : '')}
  ${(props) => (props.flexCol ? 'flex-direction: column;' : '')}
  ${(props) => (props.gap ? `gap: ${props.gap}px;` : '')}
`;

const ButtonBase = styled('button')<IButtonProps>`
  background-color: ${(props) => (props.filled ? props.theme.primaryAccentColor : props.theme.primaryAccentTextColor)};
  border-radius: 0.6rem;
  color: ${(props) => (props.filled ? props.theme.primaryAccentTextColor : props.theme.primaryAccentColor)};
  cursor: pointer;
  font-family: inherit;
  font-size: 1.6rem;
  opacity: ${(props) => (props.disabled ? 0.3 : 1)};
  padding: 1rem;
  width: 100%;
`;

export const SkipButton = styled(ButtonBase)`
  border: none;
`;

export const SubmitButton = styled(ButtonBase)`
  border: 0.1rem solid ${(props) => props.theme.primaryAccentColor};
`;
